// import proto from "../proto";
//  getDeviceID, getDeviceType,
// import { getUUID } from ".";
import utils from "../utils";
import main from "../main";
import ERROR_TYPE from "../config";
import CMD from "../constant/newCMD.js";

let websocket = undefined;

let connecting = false;
let notifyDismiss = undefined;

function getStore() {
  const { store } = main.getVueMachine();
  return store;
}

const showNotify = (ops = { message: "" }) => {
  if (notifyDismiss) return;
  utils.log("socket", ops.message || "error");
};

// 区分socket地址
let url = () => {
  const store = getStore();

  if (
    utils.isCustomer() &&
    store.state.domain &&
    store.state.domain.WEBSOCKET_URL
  ) {
    return store.state.domain.WEBSOCKET_URL + "/wss";
  } else {
    return process.env.VUE_APP_SOCKET_SERVER;
  }
};
/**
 * socket鉴权
 */
const auth = () => {
  const store = getStore();

  const tcpAuthToken = _.get(store, "state.token", "");
  // const serverId = _.get(store, "state.serverId", "");
  // let tcpAuthToken = utils.getProp("token") || "";
  utils.log("socket", `tcpAuthToken => ${tcpAuthToken}`);

  const buff = {
    cmd: CMD.CMD.C_ONCONNECT,
    data: {
      token: tcpAuthToken,
      uid: localStorage.getItem("userId"),
      device: 5
    }
  };

  if (websocket) {
    websocket.send(JSON.stringify(buff));
  }
};

/**
 * 心跳检测
 */
const heartCheck = {
  timeout: 10 * 1000,
  timeoutObj: null,
  // serverTimeoutObj: null,
  reset: function() {
    clearTimeout(this.timeoutObj);
    // clearTimeout(this.serverTimeoutObj);
    return this;
  },
  start: function() {
    this.timeoutObj = setTimeout(() => {
      utils.log("socket", "❤", { logColor: "red" });
      if (websocket) websocket.send(JSON.stringify({ cmd: "ping" }));
      // this.serverTimeoutObj = setTimeout(() => {
      //   // websocket.close();
      // }, this.timeout);
    }, this.timeout);
  }
};

const updateSocketState = () => {
  const store = getStore();
  if (websocket !== undefined) {
    store.dispatch("socketEvent", {
      socketStatus: websocket.readyState
    });
  } else {
    store.dispatch("socketEvent", {
      socketStatus: WebSocket.CLOSED
    });
  }
};

/**
 * 创建socket
 */
const createWebSocket = (isReconnect = false) => {
  return new Promise((resolve, reject) => {
    console.log(url(), "socket");
    try {
      if (connecting) {
        resolve(undefined);
        return;
      }

      connecting = true;
      utils.log("WebSocket createWebSocket");
      if ("WebSocket" in window) {
        websocket = new WebSocket(url());
      } else if ("MozWebSocket" in window) {
        websocket = new window["MozWebSocket"](url());
      } else {
        websocket = new WebSocket(url());
      }
      updateSocketState();
      initEventHandle(isReconnect);
      resolve(websocket);
    } catch (e) {
      // const device = utils.getdev();
      // utils
      //   .getlog({
      //     appId: device,
      //     // productId: commonCanstant.PRODUCTID,
      //     productId: sessionStorage.getItem("productId"),
      //     time: new Date(),
      //     lever: ERROR_TYPE.ERROR_TYPE.ERROR,
      //     msg: JSON.stringify(e)
      //   })
      //   .then(() => {
      //     console.log(e);
      //   });
      reject(e);
      reConnect();
    }
  });
};

let hideSuccessTimeout = undefined;

const socketSuccess = () => {
  if (hideSuccessTimeout) {
    clearTimeout(hideSuccessTimeout);
  }
  hideSuccessTimeout = setTimeout(() => {
    updateSocketState();
    connecting = false;
  }, 1000);
};

/**
 * 初始化事件
 */
const initEventHandle = (isReconnect = false) => {
  websocket.onopen = () => {
    updateSocketState();
    window.socket = websocket;
    utils.log("socket", "连接成功");
    const store = getStore();

    socketSuccess();

    // 重新同步
    if (isReconnect) {
      store.commit("ws/setIsReconnect", true);
    }

    if (notifyDismiss) {
      notifyDismiss();
      notifyDismiss = null;
    }
    // store.commit("socket/setStatus", true);
    auth();
    store.commit("setState", { socketstatus: true });
    // connectCounter += 1;
    // connecting = false;
  };

  websocket.onclose = e => {
    if (websocket) websocket.close();
    updateSocketState();
    utils.log("websocket 断开: " + e.code + " " + e.reason + " " + e.wasClean);
    const device = utils.getdev();
    utils
      .getlog({
        appId: device,
        // productId: commonCanstant.PRODUCTID,
        productId: sessionStorage.getItem("productId"),
        time: new Date(),
        lever: ERROR_TYPE.ERROR_TYPE.WARN,
        msg: "websocket 断开: " + e.code + " " + e.reason + " " + e.wasClean
      })
      .then(() => {
        // console.log(resData);
      });
    closeSocket();
    showNotify({
      message: "socket 关闭"
    });

    reConnect();
  };

  websocket.onmessage = evt => {
    utils.log("socket", `socket 接收消息 ${evt.data}`);
    try {
      // 派发给 socket 的 vuex 对象处理
      // store.dispatch("socket/acceptMessage", buff);

      if (
        JSON.parse(evt.data).cmd === CMD.CMD.C_SUCCESS ||
        JSON.parse(evt.data).cmd === "pong"
      ) {
        if (JSON.parse(evt.data).cmd === CMD.CMD.C_SUCCESS) {
          const store = getStore();
          store.commit("setState", {
            socketConnectSuccess: true
          });
        }
        // 心跳检测
        heartCheck.reset().start();
      }
      if (JSON.parse(evt.data).cmd === CMD.CMD.C_FAIL) {
        closeSocket();
        store.dispatch("socketEvent", {
          socketStatus: WebSocket.CLOSED
        });
      }
      // if (JSON.parse(evt.data).cmd === CMD.CMD.C_KICKOUT) {
      //   Message.warning(
      //     "亲，不能同时打开两个相同的浏览器页面，请检查是否打开了另外一个相同页面。"
      //   );
      //   closeSocket();
      // }
      const store = getStore();
      store.dispatch("chat/acceptMessage", evt.data);
    } catch (evt) {
      // const device = utils.getdev();
      utils.log("socket", `socket 接收消息catch ${JSON.stringify(evt)}`);
      // utils
      //   .getlog({
      //     appId: device,
      //     productId: commonCanstant.PRODUCTID,
      //     time: new Date(),
      //     lever: ERROR_TYPE.ERROR_TYPE.ERROR,
      //     msg: JSON.stringify(
      //       "socket",
      //       `socket 接收消息异常 ${JSON.stringify(evt)}`
      //     )
      //   })
      //   .then(() => {
      //     // console.log(resData);
      //   });
    }
  };

  websocket.onerror = e => {
    updateSocketState();
    const device = utils.getdev();
    utils.log("socket", `error => ${JSON.stringify(e)}`);
    utils
      .getlog({
        appId: device,
        // productId: commonCanstant.PRODUCTID,
        productId: sessionStorage.getItem("productId"),
        time: new Date(),
        lever: ERROR_TYPE.ERROR_TYPE.ERROR,
        msg: JSON.stringify("socket", `error => ${JSON.stringify(e)}`)
      })
      .then(() => {
        // console.log(resData);
      });
  };
};

/**
 * 重连socket
 */
export const reConnect = () => {
  utils.log(`socket`, `reConnect`);
  // if (!store.getters["user/isLogin"]) return;
  // if (connecting) return;

  // lockReconnect = true;
  setTimeout(() => {
    createWebSocket(true);
    // lockReconnect = false;
  }, 1000);
};

/**
 * 获取socket实例
 */
export const getSocket = async () => {
  // if (connecting) return undefined;
  // connecting = true;
  return websocket;
};

/**
 * 初始化socket
 */
export const initSocket = async () => {
  utils.log(`socket`, `initSocket`);
  // if (connecting) return undefined;
  if (websocket !== undefined) {
    return websocket;
  }
  return await createWebSocket();
};

/**
 * 关闭socket
 */
export const closeSocket = () => {
  websocket.close();

  if (websocket !== undefined) {
    if (connecting) connecting = false;
    heartCheck.reset();
    // websocket.close();
    websocket = undefined;
  }
  if (hideSuccessTimeout) {
    hideSuccessTimeout = undefined;
    clearTimeout(hideSuccessTimeout);
  }
};

export const send = message => {
  if (websocket === undefined) {
    utils.log(`socket`, `发送消息失败 => ${message}`);
    const device = utils.getdev();
    utils
      .getlog({
        appId: device,
        // productId: commonCanstant.PRODUCTID,
        productId: sessionStorage.getItem("productId"),
        time: new Date(),
        lever: ERROR_TYPE.ERROR_TYPE.WARN,
        msg: JSON.stringify(`socket`, `发送消息失败 => ${message}`)
      })
      .then(() => {
        // console.log(resData);
      });
    return false;
  }
  websocket.send(message);
  return true;
};

export default {
  initSocket,
  getSocket,
  send,
  reConnect,
  websocket
};
